<template>
  <div>
    <div class="ui-text bold">{{ value }}</div>
    <div style="font-size:.8em;opacity:.8" v-if="ipData">
      {{ ipData.city }}, {{ ipData.region_name }}, {{ ipData.country_name }}
      <a :href="gmLink" target="_blank" style="text-decoration: none"
        ><hi-icon tip="Google Maps">mdi-map</hi-icon></a
      >
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import HiIcon from "@/components/HiIcon";

export default {
  name: "IP",
  components: { HiIcon },
  props: {
    value: String
  },
  data() {
    return {
      ipData: null
    };
  },
  methods: {
    async getIpInfo() {
      this.ipData = await api.general.ip(this.value);

      // console.log(ip);
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.getIpInfo(v);
      }
    }
  },
  computed: {
    gmLink() {
      if (!this.ipData) return "";
      return `http://www.google.com/maps/place/${this.ipData.latitude},${this.ipData.longitude}`;
    }
  }
};
</script>

<style scoped></style>
